import createStyled from '../../../../../node_modules/.pnpm/@emotion_styled@11.14.0_@emotion_react@11.14.0_@types_react@19.0.1_react@18.3.1__@types_react@19.0.1_react@18.3.1/node_modules/@emotion/styled/base/dist/emotion-styled-base.esm.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var SpeedTest = /*#__PURE__*/createStyled("div", process.env.NODE_ENV === "production" ? {
  target: "e16bt2s80"
} : {
  target: "e16bt2s80",
  label: "SpeedTest"
})(process.env.NODE_ENV === "production" ? {
  name: "1d3w5wq",
  styles: "width:100%"
} : {
  name: "1d3w5wq",
  styles: "width:100%/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlNwZWVkVGVzdC5zdHlsZXMuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBRW1DIiwiZmlsZSI6IlNwZWVkVGVzdC5zdHlsZXMuanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCdcblxuZXhwb3J0IGNvbnN0IFNwZWVkVGVzdCA9IHN0eWxlZC5kaXZgXG4gIHdpZHRoOiAxMDAlO1xuYFxuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

export { SpeedTest };
//# sourceMappingURL=SpeedTest.styles.js.map
